import { oauthLogger } from './logging.utils';
import { HttpOperationType } from '../types/http.types';
var UrlPathType;
(function (UrlPathType) {
  UrlPathType["publicResourceGetOnly"] = "ct";
  UrlPathType["publicResourceGetOnlyWithoutCookieCheck"] = "ed";
  UrlPathType["publicResource"] = "pc";
  UrlPathType["publicResourceWithVirusScan"] = "uc";
  UrlPathType["protectedResource"] = "pd";
  UrlPathType["protectedResourceWithVirusScan"] = "ud";
  UrlPathType["extern"] = "";
})(UrlPathType || (UrlPathType = {}));
/**
 * siehe https://confluence.webapp.sdst.sbaintern.de/display/BAPF/03_Namenskonventionen
 */
const constraints = [
  {
    urlPathType: UrlPathType.protectedResource,
    isJwtNecessary: true,
    isOAuthNecessary: true,
  },
  {
    urlPathType: UrlPathType.protectedResourceWithVirusScan,
    isJwtNecessary: true,
    isOAuthNecessary: true,
  },
  {
    urlPathType: UrlPathType.publicResourceWithVirusScan,
    isJwtNecessary: false,
    isOAuthNecessary: true,
  },
  {
    urlPathType: UrlPathType.publicResource,
    isJwtNecessary: false,
    isOAuthNecessary: true,
  },
  {
    urlPathType: UrlPathType.publicResourceGetOnlyWithoutCookieCheck,
    isJwtNecessary: false,
    isOAuthNecessary: false,
    restrictedHttpMethods: [HttpOperationType.GET],
  },
  {
    urlPathType: UrlPathType.publicResourceGetOnly,
    isJwtNecessary: false,
    isOAuthNecessary: false,
    restrictedHttpMethods: [HttpOperationType.GET],
  },
  {
    urlPathType: null,
    isJwtNecessary: false,
    isOAuthNecessary: false,
  },
];
export class RequestTypeImpl {
  constructor(url, method, overrides) {
    var _a;
    this.overrides = overrides;
    oauthLogger.info('Die Auswerten des RequestType erfolgt anhand der folgenden Url: ', url);
    const urlPathType = RequestTypeImpl.getRequestType(url);
    this.requestTypeConstraint = (_a = constraints.find((value) => value.urlPathType === urlPathType)) !== null && _a !== void 0 ? _a : {
      isJwtNecessary: false,
      isOAuthNecessary: false,
      urlPathType: null,
    };
    this.httpOperation = HttpOperationType[method];
    oauthLogger.info('Constraint für den RequestType wurde mit folgendem Ergebnis ermittelt: ', this.requestTypeConstraint, '\nDer RequestType wird durch folgende Attribute überschrieben:', overrides);
  }
  static getRequestType(url) {
    const splittedUrl = url.split('/');
    return Object.values(UrlPathType).find((value) => splittedUrl.includes(value));
  }
  isJwtNecessary() {
    return !this.overrides.forceNoOam && this.requestTypeConstraint.isJwtNecessary;
  }
  isOAuthNecessary() {
    // wird ignoriert, da diese Bedingung lediglich eine unwesentliche Log-Ausgabe ausgibt. Unwesentlich deshalb,
    // weil die Sicherheitsinfrastruktur entgegen dem Inhalt der Logausgabe durchaus andere HTTP-Methoden zulässt.
    // prettier-ignore
    /* istanbul ignore next */
    if (this.requestTypeConstraint.restrictedHttpMethods && !this.requestTypeConstraint.restrictedHttpMethods.includes(this.httpOperation)) { // NOSONAR
      oauthLogger.error(`Http-Methode ${this.httpOperation} ist nur geduldet. Es sind nur GET Methoden erlaubt i.V.m. dem Endpunkt "${this.requestTypeConstraint.urlPathType}"!`);
    }
    return !this.overrides.forceNoOag && (this.isJwtNecessary() || this.requestTypeConstraint.isOAuthNecessary);
  }
}
/**
 * Erstellt eine Instanz von RequestOptions mittels den übergebenen Parametern. Diese werden benötigt, um zu bestimmen,
 * welche Anfragen an die Sicherheitsinfrastruktur zu senden sind und beinhalten auch deren Antworten. Diese Antworten werden
 * anschließend benötigt, wenn die ursprüngliche Anfrage gesendet wird.
 * @param url
 * @param options
 * @param baOAuthLibConfig
 */
export function createRequestOptions(url, options, baOAuthLibConfig) {
  const requestOptions = options
    ? Object.assign(Object.assign({}, options), { headers: new Headers(options.headers), method: options.method || 'GET' }) : { method: 'GET', headers: new Headers() };
  requestOptions.headers = new Headers(requestOptions.headers);
  requestOptions.requestType = (options === null || options === void 0 ? void 0 : options.hasOwnProperty('requestType'))
    ? options['requestType']
    : new RequestTypeImpl(url, requestOptions.method, {
      forceNoOag: (baOAuthLibConfig === null || baOAuthLibConfig === void 0 ? void 0 : baOAuthLibConfig.oagUrl) == null,
      forceNoOam: (baOAuthLibConfig === null || baOAuthLibConfig === void 0 ? void 0 : baOAuthLibConfig.oamHost) == null,
    });
  return requestOptions;
}
//# sourceMappingURL=request.utils.js.map
